import React from 'react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { RegularButton as Button, RegularButtonProps } from 'fronton-react';

const FooterButton = (props: RegularButtonProps) => (
  <Button
    role="button"
    size={props.size}
    variant="primary"
    label="Рассчитать"
    type="submit"
    form="dimensions-form"
    {...(props.wide ? { wide: props.wide } : {})}>
    Рассчитать
  </Button>
);

export const DimentionsFooter = () => {
  const { tablet, mobile } = useBreakpoints() ?? {};
  return tablet || mobile ? <FooterButton size="l" wide /> : <FooterButton size="l" />;
};
